import React from "react";
import tw from "twin.macro";

/*
 * Presents a real product screenshot inside a minimal browser frame.
 * Screenshots are taken from the live app using the Acme demo tenant, so
 * every name and case shown is fictional seed data.
 */
const Frame = tw.figure`m-0 rounded-xl border border-gray-200 bg-white shadow-xl overflow-hidden`;
const Bar = tw.div`flex items-center gap-1.5 px-4 py-3 border-b border-gray-200 bg-gray-100`;
const Dot = tw.span`block w-2.5 h-2.5 rounded-full bg-gray-300`;
const Url = tw.span`ml-3 text-xs text-gray-600 truncate`;
const Img = tw.img`block w-full h-auto`;

export default ({ src, alt, url = "app.ethoshub.io", className, eager = false }) => (
  <Frame className={className}>
    <Bar aria-hidden="true">
      <Dot /><Dot /><Dot />
      <Url>{url}</Url>
    </Bar>
    <Img src={src} alt={alt} loading={eager ? "eager" : "lazy"} />
  </Frame>
);
